/**
 * @module isTrustedDomain
 */

/**
 * @constant
 * A Default version for client configuration API
 */

const isTrustedDomain = (domain: string): boolean => {
    const trustedDomains = [
        'https://outlook.office365.com',
        'https://outlook.office.com',
        'https://outlook-sdf.office.com',
        'https://outlook-sdf.office365.com',
        'https://emea.mail.microsoft.com',
        'https://outlook-sdf.live.com',
        'https://outlook.live.com',
    ];
    return trustedDomains.includes(domain);
};

export default isTrustedDomain;
